import { Flex, Rte, Text } from "@capioweb/ui-components"
import React from "react"
import { createMarkup } from "../../utils"
import { resolveBmiDisplayValue } from "./utils/resolveBmiDisplayValue"

interface Props {
	bmi: number
	description: string
	yourBmiText: string
}

export const BmiResult: React.FC<Props> = ({
	bmi,
	description,
	yourBmiText,
}) => {
	return (
		<Flex
			flexDirection={"column"}
			py={4.5}
			px={{ _: 3, l: 19.5 }}
			width={"100%"}
		>
			<Text variant={"headline-4"}>
				{`${yourBmiText} = ${resolveBmiDisplayValue(bmi)}`}
			</Text>
			<Rte>
				<div dangerouslySetInnerHTML={createMarkup(description)}></div>
			</Rte>
		</Flex>
	)
}
